import { useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export default function useMarketTransactions() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTransactions = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/market/transactions/`);
      setTransactions(res.data);
    } catch (e) { /* no profile */ }
    finally { setLoading(false); }
  }, []);

  return { transactions, loading, fetchTransactions };
}
